module.exports = __webpack_public_path__ + "static/media/IMG_1408.4d90db6d.JPG";